module.exports = __webpack_public_path__ + "img/19 Aniamtion 3-squashed.ad6e0724.jpg";